import { render, staticRenderFns } from "./SuccessDialog.vue?vue&type=template&id=59aff21d&scoped=true&"
import script from "./SuccessDialog.vue?vue&type=script&lang=js&"
export * from "./SuccessDialog.vue?vue&type=script&lang=js&"
import style0 from "./SuccessDialog.vue?vue&type=style&index=0&id=59aff21d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59aff21d",
  null
  
)

export default component.exports